// src/components/ShareButtons.js
import React from "react";
import styled from "styled-components";
import { motion } from "framer-motion";
import { Share2, Copy } from "lucide-react";

/* ---------- стили ---------- */

/* горизонтальный ряд кнопок */
const Row = styled.div`
  display: flex;
  gap: 1rem;
  align-items: center;
`;

/* обёртка для Copy-кнопки (position: relative) */
const CopyWrap = styled.div`
  position: relative;
  display: inline-flex;
`;

/* универсальная кнопка */
const Btn = styled(motion.button)`
  --clr: #930707;

  display: flex;
  align-items: center;
  gap: 0.5rem;

  padding: 0.8rem 2.2rem;
  border: none;
  border-radius: 30px;
  font-family: "Anybody", sans-serif;
  font-weight: 800;
  font-size: 1.05rem;
  text-transform: uppercase;

  background: var(--clr);
  color: #fff;
  cursor: pointer;

  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.35);
  transition: filter 0.25s;

  &:hover        { filter: brightness(1.15); }
  &:focus-visible{ outline: 3px solid #fff; outline-offset: 2px; }
  &:active       { box-shadow: 0 2px 8px rgba(0, 0, 0, 0.45); }
`;

/* сообщение «Copied ✔» — растягиваем на ширину кнопки и центрируем */
const CopyMsg = styled(motion.span)`
  position: absolute;
  top: -1.7rem;         /* чуть выше кнопки */
  left: 0;
  right: 0;             /* растянуть на всю ширину */
  display: flex;
  justify-content: center;

  font-family: "Anybody", sans-serif;
  font-weight: 700;
  color: #930707;

  pointer-events: none;
  white-space: nowrap;
`;

/* ---------- компонент ---------- */

export function ShareButtons() {
  const url = window.location.href;
  const [copied, setCopied] = React.useState(false);

  const copyLink = async () => {
    await navigator.clipboard.writeText(url);
    setCopied(true);
    setTimeout(() => setCopied(false), 2200);
  };

  const share = async () => {
    try {
      if (navigator.share) {
        await navigator.share({ title: "My personal soundscape on RIFF AI", url });
      } else {
        await copyLink();
      }
    } catch { /* cancel */ }
  };

  return (
    <Row>
      {/* SHARE */}
      <Btn
        whileHover={{ scale: 1.05 }}
        whileTap={{ scale: 0.92 }}
        onClick={share}
      >
        <Share2 size={20} strokeWidth={2.6} />
        Share
      </Btn>

      {/* COPY + Copied ✔ */}
      <CopyWrap>
        <Btn
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.92 }}
          onClick={copyLink}
        >
          <Copy size={20} strokeWidth={2.6} />
          Copy&nbsp;Link
        </Btn>

        {copied && (
          <CopyMsg
            initial={{ opacity: 0, y: 8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0 }}
          >
            Copied&nbsp;✔
          </CopyMsg>
        )}
      </CopyWrap>
    </Row>
  );
}
